var awards = [
  {
    id: 0,
    name: "Sara Pfaff Photojournalism Cup",
    issuer: "Bexley High School",
    date: "May 2020",
    description:
      "<ul><li>Award presented to the senior executive editors in charge of the Bexleo yearbook publication</li></ul>",
  },
  {
    id: 1,
    name: "Faculty Award",
    issuer: "Bexley High School",
    date: "May 2020",
    description:
      "<ul><li>Award given annually by the school staff to the two most well-rounded students in the graduating class</li></ul>",
  },
  {
    id: 2,
    name: "AP Scholar with Distinction",
    issuer: "College Board",
    date: "July 2019, July 2020",
    description:
      "<div><p>Award qualifications:</p><ul><li>Receive an average score of at least 3.5 on all AP Exams taken</li><li>Score 3 or higher on five or more of these exams</li></ul></div>",
  },
  {
    id: 3,
    name: "National AP Scholar",
    issuer: "College Board",
    date: "July 2020",
    description:
      "<div><p>Award qualifications:</p><ul><li>Receive an average score of at least 4 on all AP Exams taken</li><li>Score 4 or higher on eight or more of these exams</li></ul></div>",
  },
];

module.exports = { awards };